import React, { useEffect, useState } from 'react';
import SectionTitle from '../Common/SectionTitle';

const SharePro = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Use process.env.PUBLIC_URL for image paths
  const imagePaths = {
    heroImg: `https://stansoftware.com/wp-content/uploads/2023/03/sharePro_Desktop.png`,
    logoImg: `https://stansoftware.com/wp-content/uploads/2021/10/Stansoft-Logo-1-1.png`,
    heroBgImg: `${process.env.PUBLIC_URL}/assets/img/hero-bg-2.jpg`,
    testimonialsBgImg: `${process.env.PUBLIC_URL}/assets/img/testimonials-bg.jpg`
  };
  
  // Set correct page title and scroll to top when component mounts
  useEffect(() => {
    document.title = "SharePro Solutions | Digisoft";
    window.scrollTo(0, 0);
    
    // Force update header visibility
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');
    
    if (header) {
      header.style.display = 'flex';
      header.style.visibility = 'visible';
      header.style.opacity = '1';
      header.style.position = 'fixed';
    }
    
    if (topBar) {
      topBar.style.display = 'block';
      topBar.style.visibility = 'visible';
      topBar.style.opacity = '1';
    }

    // Check if mobile view
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      document.title = "Digisoft Services";
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const shareProProducts = [
    {
      id: 'desktop',
      title: 'SharePro Desktop',
      description: 'The SharePro Desktop is the core-component of the SharePro Backoffice Suite, the workhorse and the operations center of the broking business. The teams at HO use this application to manage and run the broking show. Easy to use, easy to learn.',
      link: 'http://stansoftware.com/sharepro/',
      icon: 'pc-display'
    },
    {
      id: 'connect',
      title: 'SharePro Connect',
      description: 'SharePro Connect is the server application that caters to Clients, Branches, APs, Employees, Fund Managers, etc., through the web browser. Built using the latest web technologies and libraries, it is the face of your organization to the outside world.',
      link: 'http://stansoftware.com/sharepro-crm/',
      icon: 'hdd-network'
    },
    {
      id: 'liverms',
      title: 'Live RMS',
      description: 'SharePro Live is the server-application that calculates your risks and Margins on a near-realtime basis. It serves as the backbone of the risk presentation while the markets are in session. RMS teams at the HO can view the LiveRMS using the standard SharePro Desktop application.',
      link: 'http://stansoftware.com/live-rms/',
      icon: 'graph-up'
    },
    {
      id: 'pms',
      title: 'SharePro PMS',
      description: 'If you are a SEBI Registered Fund Manager or an Advisory Service, SharePro PMS is just the kind of product that you need to service customers and regulators and manage your books. Integrates with SharePro Desktop and also available standalone.',
      link: 'http://stansoftware.com/pms-fund-manager/',
      icon: 'wallet'
    },
    {
      id: 'rekyc',
      title: 'reKYC',
      description: 'Clients logged into the web version can lodge Modification or Closure requests using Aadhaar eSigning. Agents at HO accept or reject the requests based on submitted documents.',
      link: 'http://stansoftware.com/rekyc/',
      icon: 'person-check'
    },
    {
      id: 'mtf',
      title: 'Margin Trading Facility',
      description: '"Margin Trading Facility" or MTF supports your Funding operation to Clients against Collateral deposits, and all using the same Trading UCC. Handles operation, reporting, and MIS.',
      link: 'http://stansoftware.com/mtf/',
      icon: 'cash-stack'
    },
    {
      id: 'depositories',
      title: 'Depositories',
      description: 'The SharePro CDSL/NSDL module help you manage the complete operations of DP. Starting with entering the new client account details to upload to the DPM/CDAS system and then updating the backoffice with the return files to create the new Beneficiary account either for a client or a clearing member.',
      link: 'http://stansoftware.com/depository-participants/',
      icon: 'building'
    },
    {
      id: 'service',
      title: 'Service Management',
      description: 'Get the world\'s most popular customer support ticket system in SharPro. osTicket is a widely-used and trusted open source support ticketing system. It seamlessly routes inquiries created via email, web forms, and phone calls into a simple, easy-to-use, multi-user, web-based customer support platform.',
      link: 'http://stansoftware.com/service-ticket-system/',
      icon: 'headset'
    },
    {
      id: 'scheduler',
      title: 'SharePro Scheduler',
      description: 'The SharePro Scheduler – is an essential component for automating retail broking operations. All outgoing pre-formatted emails (signed or unsigned) are routed through this system. Initially designed to digitally sign and send documents, today even SMSs including OTPs are also routed through the Scheduler.',
      link: 'http://stansoftware.com/scheduler/',
      icon: 'calendar-check'
    },
    {
      id: 'nbfcs',
      title: 'NBFCs',
      description: 'NBFC (Non-Banking Finance Company) Financing of Shares with a tie-up with a brokerage firm can be a daily 10 minute operation. Similarly routing securities from the Client\'s DP to the NBFC and later transferring from NBFC to Client for onward',
      link: 'http://stansoftware.com/nbfcs/',
      icon: 'bank'
    },
    {
      id: 'sales',
      title: 'Sales Management',
      description: 'Sales management is the coordination of people & resources to reach a sales goal. Sales management is a business discipline which is focused on the practical application of sales techniques and the management of a firm\'s sales operations.',
      link: 'http://stansoftware.com/sales-management/',
      icon: 'cart-check'
    },
    {
      id: 'air',
      title: 'SharePro AIR',
      description: 'With the SharePro AIR Mobile App for iOS and Android clients, stay in touch with you 24/7. Using the free SharePro AIR App, your clients can access their Portfolios, Ledgers, Obligations, DP holdings, Dues and Balances from anywhere!',
      link: 'http://stansoftware.com/sharepro-air/',
      icon: 'phone'
    },
    {
      id: 'pvm',
      title: 'PVM',
      description: 'PWM, short for "Personal Wealth Management" system, is an invaluable Accounting and MIS tool for an Individual or Corporate dealing in the Indian Stock Markets.',
      link: 'http://stansoftware.com/personal-wealth-manager/',
      icon: 'piggy-bank'
    },
    {
      id: 'api',
      title: 'API Bundle',
      description: 'SharePro exposes itself to third-party tools and systems with published REST API. Simply get the API and integrate reports and features of the system.',
      link: 'http://stansoftware.com/api-bundle/',
      icon: 'code-square'
    },
    {
      id: 'mf',
      title: 'MF Distribution',
      description: 'The SharePro Desktop is the core-component of the SharePro Backoffice Suite, the workhorse and the operations center of the broking business. The teams at HO use this application to manage and run the broking show. Easy to use, easy to learn.',
      link: 'http://stansoftware.com/sharepro/',
      icon: 'currency-exchange'
    }
  ];

  // Hero section background style
  const heroBackgroundStyle = {
    backgroundImage: `url(${imagePaths.heroBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.4,
    margin: 0,
    padding: 0
  };

  // CTA section background style
  const ctaBackgroundStyle = {
    backgroundImage: `url(${imagePaths.testimonialsBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: '40%'
  };

  // Featured products - the first 4 will be highlighted
  const featuredProducts = shareProProducts.slice(0, 4);
  // Other products
  const otherProducts = shareProProducts.slice(4);

  return (
    <div id="details-sharepro" className="sharepro-page p-0">
      {/* Hero Section */}
      <section className="sharepro-hero pt-5 section dark-background position-relative">
        <div style={heroBackgroundStyle}></div>
        <div className="container py-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold mb-4">SharePro</h1>
              <p className="lead mb-4">
                A comprehensive suite of financial software solutions designed for brokers, financial advisors, 
                and wealth managers to efficiently manage operations and provide superior client service.
              </p>
              <div className="d-flex gap-2">
                <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
                <a href="#sharepro-products" className="btn btn-outline-light btn-lg">Explore Solutions</a>
              </div>
            </div>
            <div className="col-lg-6 text-center">
              <img 
                src={imagePaths.heroImg} 
                alt="SharePro Desktop" 
                className="img-fluid rounded shadow" 
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section id="sharepro-products" className="sharepro-featured py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="Featured Solutions" 
            description1="Core" 
            description2="Products" 
          />
          
          <div className="row mt-5 g-4">
            {featuredProducts.map((product, index) => (
              <div key={product.id} className="col-lg-6" data-aos="fade-up" data-aos-delay={(index * 100)}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div 
                        className="feature-icon me-3 p-3 rounded-circle text-white d-flex align-items-center justify-content-center" 
                        style={{ 
                          backgroundColor: '#7b00ff',
                          width: '60px',
                          height: '60px',
                          minWidth: '60px'
                        }}
                      >
                        <i className={`bi bi-${product.icon} fs-4`}></i>
                      </div>
                      <h3 className="card-title h4 mb-0">{product.title}</h3>
                    </div>
                    <p className="card-text text-muted">{product.description}</p>
                    <a href={product.link} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary mt-2">
                      Learn More <i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Products Grid Section */}
      <section className="sharepro-all-products py-5 section">
        <div className="container py-5">
          <SectionTitle 
            title="Complete Solution Suite" 
            description1="Explore All" 
            description2="Products" 
          />
          
          <div className="row mt-5 g-4">
            {otherProducts.map((product, index) => (
              <div key={product.id} className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={(index % 3) * 100}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="feature-icon me-3 text-primary">
                        <i className={`bi bi-${product.icon} fs-4`}></i>
                      </div>
                      <h3 className="card-title h5 mb-0">{product.title}</h3>
                    </div>
                    <p className="card-text small text-muted">{product.description}</p>
                    <a href={product.link} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-link p-0 text-primary">
                      Learn More <i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partner Logo Section */}
      <section className="partners py-5 section light-background">
        <div className="container py-5 text-center">
          <h2 className="h3 mb-5">Trusted Partner for Financial Services</h2>
          <img 
            src={imagePaths.logoImg} 
            alt="Stan Software Logo" 
            className="img-fluid" 
            style={{ 
              maxHeight: '80px',
              filter: 'grayscale(100%)',
              opacity: '0.8',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.filter = 'grayscale(0%)';
              e.target.style.opacity = '1';
            }}
            onMouseOut={(e) => {
              e.target.style.filter = 'grayscale(100%)';
              e.target.style.opacity = '0.8';
            }}
          />
        </div>
      </section>

      {/* Benefits Section */}
      <section className="sharepro-benefits py-5 section">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <h2 className="h1 fw-bold mb-4">Why Choose SharePro?</h2>
              <p className="lead mb-4">
                SharePro offers a complete ecosystem for broking firms and financial services organizations, 
                providing everything from core back office operations to client-facing mobile apps.
              </p>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Comprehensive solution suite with seamless integration</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Robust risk management and compliance tools</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Scalable architecture for growing businesses</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Modern client-facing interfaces across web and mobile</p>
              </div>
            </div>
            <div className="col-lg-7">
              <img 
                src={imagePaths.heroImg} 
                alt="SharePro Desktop Interface" 
                className="img-fluid rounded shadow-lg" 
                style={{ 
                  maxWidth: '100%',
                  transform: isMobile ? 'none' : 'perspective(1000px) rotateY(-5deg)',
                  transition: 'transform 0.5s ease'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta py-5 section dark-background position-relative">
        <div 
          style={ctaBackgroundStyle} 
          className="position-absolute top-0 start-0 w-100 h-100"
        ></div>
        <div className="container py-5 text-center position-relative">
          <h2 className="mb-4">Ready to transform your financial services business?</h2>
          <p className="mb-4 lead">Experience the power of integrated solutions designed specifically for broking and wealth management.</p>
          <div className="d-flex justify-content-center gap-3">
            <a href="#contact" className="btn btn-primary btn-lg">Contact Us Today</a>
            <a href="http://stansoftware.com/sharepro/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light btn-lg">Visit Official Website</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SharePro; 